'use client';

import { assert } from '@core/utils';
import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, BOOKMARK_TYPE, UnauthQueryOptions } from '@/api';
import { BookmarkButton } from '@/components/molecule/BookmarkButton';
import { useBookmark } from '@/hooks/useBookmark';
import { useAuthStore } from '@/stores/AuthStore';

interface HometownNewsBookmarkButtonProps {
  idIdx: string;
}

export const HometownNewsBookmarkButton = ({
  idIdx,
}: HometownNewsBookmarkButtonProps) => {
  const isLogin = useAuthStore((state) => !!state.isLogin);

  const { data: id } = useQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/hometown-news/{hometownNewsIdIdx}'
    ]({
      path: {
        hometownNewsIdIdx: idIdx,
      },
    }),
    select: ({ context }) => context?.detailHometownNews?.hometownNewsId,
  });

  const feedbackQuery = useQuery({
    ...(isLogin
      ? AuthQueryOptions[
          'get:/wello/v2/auth/hometown-news/feedback/{hometownNewsId}'
        ]
      : UnauthQueryOptions[
          'get:/wello/v2/allows/hometown-news/feedback/{hometownNewsId}'
        ])({
      path: {
        hometownNewsId: id!,
      },
    }),
    enabled: isLogin !== undefined && !!id,
    select: ({ context }) => ({
      isBookmarked: context?.wishlistYN,
      bookmarkCount: context?.wishlistCount,
    }),
  });

  const { bookmark } = useBookmark();

  return (
    <BookmarkButton
      {...feedbackQuery.data}
      onClick={(isBookmarked) => {
        assert(id);

        bookmark({
          bookmarkType: BOOKMARK_TYPE.HOMETOWN_NEWS,
          contentId: id,
          isBookmarked,
          idx: idIdx,
        });
      }}
    />
  );
};
